import { z } from "zod";

const schema = z.object({
  linkedIn: z.string().optional(),
  personalWebsite: z.string().optional(),
  resume: z.instanceof(File).optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateLinksFormSchema,
  type Schema as CandidateLinksFormSchema,
};
